import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiWalletStatementBonus, ApiResult } from 'Types'

const endpoint = `${apiUrl.stable}/bonus`

/** Returns the  assigned bonus from the current signed company */
export const getBonusBalance = (): ApiResult<ApiWalletStatementBonus> => {
  const url = `${endpoint}/saldo`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export default {
  getBonusBalance
}